import { VzPageContainer } from "../../layouts/VzPageContainer";
import { useEffect, useState, useRef } from "react";
import { Modal, Row, Col, Container, Button } from "react-bootstrap";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import FormikControl from "../../layouts/Input/FormikControl";
import { toast } from "react-toastify";
import {
  addUsers,
  getUsers,
  updateUsers,
  deleteUsers,
  getUserRoles,
  getUserRolesList,
  toggleUserStatus,
  updateUserPasswordThroughEmail,
} from "./ManageUsersAction";
import ServerSideDataTable from "../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import ReactSelect from "react-select";
import { GET_DISTRIBUTOR_DDL, GET_DISTRIBUTIONCENTER_DDL,GET_CITIES } from "../../Types";
import { getDropdownList, getDropdownListByPost } from "../Shared/dropdownListActions";
import { getUserRoles as getRolesList } from "../Settings/Permissions/UserRoles/UserRolesActions";
import storage from "../../apis/Storage";
import { AllowOnlyAlpha, AllowOnlyAlphaNumeric, AllowUsernameChar, formatNumber, IsValidPassword, removeFormatFromNumber } from "../../utilities/Validations";
import { DocDBElastic } from "aws-sdk";

const ManageUsers = (props) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const clickedButton = useRef("");

  const [userType, setUserType] = useState(null);
  const [distributor, setDistributor] = useState([]);
  const [distributorUserList, setDistributorUserList] = useState([]);
  const [distributorUserListFull, setDistributorUserListFull] = useState([]);

  const [selectAll, setSelectAll] = useState(false);
  const [searchCenter, setSearchCenter] = useState("");
  const [userRole, setUserRole] = useState("");

  const [isView, setIsView] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [city, setCityValue] = useState(null);

  const validationSchema = Yup.object().shape({
    fullName: Yup.string().required("Full Name is required"),
    cnic: Yup.string().required("CNIC is Required"),
    contactNumber: Yup.string().required("Contact Number is Required"),

    userType: Yup.string()
      .nullable()
      .test("moduleType-required", "Module Type is Required", function (value) {
        if (isEdit) return true; // Assuming userType is a string
        return !!(value && value.trim());
      }),

    email: Yup.string().when("userType", {
      is: (val) => val !== "4", // only validate when userType is not "4"
      then: (schema) =>
        schema
          .email("Enter correct Email")
          .required("Email is Required"),
      otherwise: (schema) => schema.notRequired() // skip validation for userType = 4
    }),

    userRole: Yup.string()
      .nullable()
      .test(
        "userRole-required",
        "User Role is required if Custom Role is empty",
        function (value) {
          const { newUserRole, userType } = this.parent;
          if (userType !== "6") return true; // Assuming userType is a string
          return (
            !!(value && value.trim()) || !!(newUserRole && newUserRole.trim())
          );
        }
      ),
    newUserRole: Yup.string().test(
      "newUserRole-required",
      "Custom Role is required if User Role is empty",
      function (value) {
        const { userRole, userType } = this.parent;
        if (userType !== "6" || userType?.value === "13") return true;
        return !!(value && value.trim()) || !!(userRole && userRole.trim());
      }
    ),
     distributor: Yup.mixed().test(
        "distributor-required",
        "Distributor is required.",
        function (value) {
          if (userType?.value === 10) {
            return Array.isArray(value) && value.length > 0;
          }
          if (userType?.value === 6) {
            return !!value;
          }
          return true;
        }
      ),
    userName: Yup.string().test(
      "userName-required",
      "UserName is required.",
      function (value) {
        if (userType?.value === "6" || userType?.value === "7" || userType?.value === "13") return true;
        return !!(value && value.trim());
      }
    ),
    password: Yup.string()
      .test('password-required', 'Password is required', function (value) {
        if (userType?.value === "6" || userType?.value === "7" || userType?.value === "4" || userType?.value === "13") return true;
        return value === undefined || value === null ? false : true;
      })
      .test('password-check', 'Password must be at least 8 characters long or include a special character, a numeric, an uppercase letter, or a lowercase letter.', function (value) {
        if (userType?.value === "6" || userType?.value === "7" || userType?.value === "13") return true;
        return !!IsValidPassword(value);
      }),
   city: Yup.mixed().test(
    "city-required",
    "City is required.",
    function (value) {
      if (userType?.value !== "13") return true;
      const citiesToCheck = value?.length > 0
        ? value
        : currentUser?.city || [];
      if (typeof citiesToCheck === "string") {
        return citiesToCheck.trim().length > 0;
      }
      if (Array.isArray(citiesToCheck)) {
        return citiesToCheck.length > 0;
      }
      return false;
    }
  ),
  });

  const columns = [
    {
      Header: "Full Name",
      accessor: "fullName",
    },
    {
      Header: "Username",
      accessor: "userName",
    },
    {
      Header: "Module Type",
      accessor: "userType",
    },
    {
      Header: "Role",
      accessor: "userRoleName",
    },
    {
      Header: "CNIC",
      accessor: "cnic",
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Is-Active",
      id: "active",
      accessor: "id",
      Cell: ({ row: { original } }) => (
        <div>
          <button
            title="Toggle User Active Status"
            onClick={() => toggleActive(original.userName)}
            className=" btn btn-sm"
            style={{ color: "#e84d15", backgroundColor: "transparent" }}
          >
            <i
              className={
                original.isActive
                  ? "fas fa-toggle-on fa-2x"
                  : "fas fa-toggle-off fa-2x"
              }
            ></i>
          </button>
        </div>
      ),
    },
    {
      Header: "Actions",
      id: "edit",
      accessor: "id",
      Cell: ({ row: { original } }) => (
        <div>
          <button
            title="View User Details"
            onClick={() => View(original.id)}
            className=" btn btn-sm"
          >
            <i className="fas fa-eye"></i>
          </button>
          <button
            style={{ marginLeft: "10px" }}
            title="Update User Role"
            onClick={() => Edit(original.id)}
            className=" btn btn-sm"
          >
            <i className="fas fa-edit"></i>
          </button>
        </div>
      ),
    },
  ];

  const initialValues = {
    id: "",
    fullName: "",
    cnic: "",
    contactNumber: "",
    email: "",
    userType: "",
    newUserRole: "",
    userRole: "",
    distributor: [],
    password: "",
    userName: "",
    city: [],
  };

  //Pagination
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchText, setSearchText] = useState("");

  const [rolesList, setRolesList] = useState("");
  const [rolesListOrignal, setRolesListOrignal] = useState("");
  const [userRolesList, setUserRolesList] = useState("");
  const [userRolesListForModal, setUserRolesListForModal] = useState("");
  const [filterRole, setFilterRole] = useState();
  const [filterUserRole, setFilterUserRole] = useState();
  const [filteredUserRoles, setFilteredUserRoles] = useState([]);

  const getData = (page) => {
    setCurrentPageNo(page);
    let requestData = {
      pageSize: currentPageSize,
      pageNo: page,
      searchText: searchText,
      role: filterRole == "" || filterRole == null ? null : filterRole.value,
      userRole:
        filterUserRole == "" || filterUserRole == null
          ? null
          : filterUserRole.value,
    };
    props.getUsers(requestData);
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);
    setCurrentPageSize(pageSize);
    let requestData = {
      pageSize: pageSize,
      pageNo: 0,
      searchText: searchText,
      role: filterRole == "" || filterRole == null ? null : filterRole.value,
      userRole:
        filterUserRole == "" || filterUserRole == null
          ? null
          : filterUserRole.value,
    };
    props.getUsers(requestData);
  };

  const searchChanged = (text) => {
    setCurrentPageNo(0);
    setSearchText(text);
  };

  const filterCenters = (event) => {
    setSearchCenter(event.target.value);
    let values = [...distributorUserListFull];
    values = values.filter((x) =>
      x.label.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setDistributorUserList(values);
  };

  const clearDistributorSection = () => {
    setDistributorUserList([]);
    setDistributorUserListFull([]);
    setSelectAll(false);
    setSearchCenter("");
    setDistributor(null);
  };

  useEffect(() => {
    setCurrentPageNo(0);
    let requestData = {
      pageSize: currentPageSize,
      pageNo: 0,
      searchText: searchText,
      role: filterRole == "" || filterRole == null ? null : filterRole.value,
      userRole:
        filterUserRole == "" || filterUserRole == null
          ? null
          : filterUserRole.value,
    };
    props.getUsers(requestData);
  }, [searchText]);

  useEffect(() => {
    setCurrentPageNo(0);
    let requestData = {
      pageSize: currentPageSize,
      pageNo: 0,
      searchText: searchText,
      role: filterRole == "" || filterRole == null ? null : filterRole.value,
      userRole:
        filterUserRole == "" || filterUserRole == null
          ? null
          : filterUserRole.value,
    };
    props.getUsers(requestData);
  }, [filterRole, filterUserRole]);

  useEffect(() => {
    if (props.Users && props.Users.length > 0) {
      setTotalRecords(props.Users[0].totalRecords);
    } else {
      setTotalRecords(0);
    }
    setModalShow(false);
  }, [props.Users]);

  useEffect(() => {
    setRolesList(
      props.Roles.map(function (item) {
        return {
          value: item.id,
          label: item.name,
        };
      })
    );
    setRolesListOrignal(
      props.Roles.map(function (item) {
        return {
          value: item.id,
          label: item.name,
        };
      })
    );
  }, [props.Roles]);

  useEffect(() => {
    let roles = props.UserRolesList;

    setUserRolesList(
      roles.map(function (item) {
        return {
          value: item.id,
          label: item.name,
        };
      })
    );
  }, [props.UserRolesList]);

  useEffect(() => {
    
    props.getUserRoles();
    props.getUserRolesList();
    
   
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL
    );
    props.getRolesList();

    props.getDropdownList(`api/City`,
       GET_CITIES
      );
  }, []);

  useEffect(() => {
    
    if (distributor) {
      setDistributorUserList([]);
      setDistributorUserListFull([]);
      let distributorId;
      if (userType === "CoreAppUser") {
          distributorId = distributor ? distributor.map(v => v.value) : [];
              } else {
              distributorId = distributor ? distributor.value : "";
              }
              if(distributorId)
             {
              props.getDropdownListByPost(
                `api/DistCenter/GetDistCentersDDL`,
                {distributorIds: distributorId},
                GET_DISTRIBUTIONCENTER_DDL
              );
             }
    }
  }, [distributor]);


const selectDistributors = (city) => {
  if (city && city.length > 0) {
    const cityParam = Array.isArray(city)
      ? city.map(c => c.value || c).join(",")
      : city;
    props.getDropdownList(
      `api/Distributor/GetDistributorsbyCityDDL/${cityParam}`,
      GET_DISTRIBUTOR_DDL
    );
  } else {
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL
    );
  }
};



const handleDistributorSelection = (tempObj) => {
  if (
    tempObj.userType === "DistributorUser" ||
    tempObj.userType === "DeliveryUser" ||
    tempObj.userType === "CoreAppUser"
  ) {
    if (tempObj?.distributorId) {
      if (tempObj.userType === "CoreAppUser") {
        const distributorIds = tempObj.distributorId.split(",");
        const selectedDistributors = props.allDistributorList.filter(x =>
          distributorIds.includes(x.value.toString())
        );
        setDistributor(selectedDistributors);
      } else {

        const selectedDistributor = props.allDistributorList.find(
          x => x.value.toString() === tempObj.distributorId.toString()
        );
        setDistributor(selectedDistributor);
      }
    } else {
      setDistributor([]);
    }
  }
};

const distributorOptions = [
  ...(userType?.label === "CoreAppUser"
    ? [{ label: "Select All", value: "ALL" }]
    : []),
  ...props.allDistributorList,
];



  useEffect(() => {
    
    let setInitialCheck = false;
    if (userType?.label == "Distributor") {
      setInitialCheck = true;
    }

    if ((isView || isEdit) && currentUser != null) {
      currentUser.contactNumber = formatNumber(currentUser.contactNumber, true);
      currentUser.cnic = formatNumber(currentUser.cnic, false);
      let tempObj = currentUser;
      if (
        tempObj.userType == "DistributorUser" ||
        tempObj.userType == "DeliveryUser" ||
        tempObj.userType == "CoreAppUser"
      ) {
        if (tempObj.isAllDistCenters == true) {
          setSelectAll(true);
        } else {
          setSelectAll(false);
        }
        let values = {};
        if (!tempObj.distCenterIds) {
          values = props.distCentersddlList.map((x) => {
            return {
              value: x.value,
              label: x.label,
              isChecked: false,
            };
          });
        } else {
          values = props.distCentersddlList.map((x) => {
            return {
              value: x.value,
              label: x.label,
              isChecked: tempObj.distCenterIds.includes(x.value) ? true : false,
            };
          });
        }
        setDistributorUserList(values);
        setDistributorUserListFull(values);
      }
    } else {
      setDistributorUserList(
        props.distCentersddlList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
            isChecked: setInitialCheck,
          };
        })
      );
      setDistributorUserListFull(
        props.distCentersddlList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
            isChecked: setInitialCheck,
          };
        })
      );
      setSelectAll(setInitialCheck);
    }
  }, [props.distCentersddlList, currentUser]);

  const View = (id) => {
    storage.set("_saveUserData", JSON.stringify(props.Users));
    let users = JSON.parse(storage.get("_saveUserData"));
    let tempObj = users.find((detail) => detail.id === id);
    if (tempObj == null) {
      return;
    }
    setUserType({ label: tempObj.userType, value: tempObj.userType });
    setUserRole({ label: tempObj.userRoleName, value: tempObj.userRoleId });

     handleDistributorSelection(tempObj);

    setUserRolesListForModal(
      props.UserRolesList.filter(
        (x) => x.moduleTypeId == tempObj.userTypeId
      ).map(function (item) {
        return {
          value: item.id,
          label: item.name,
        };
      })
    );

    let values = [...distributorUserList];
    values.forEach((x) => {
      x.isChecked =
        x.value == tempObj.distCenterId?.toUpperCase() ? true : false;
    });

   if (tempObj.city) {
    const cityNames = Array.isArray(tempObj.city)
      ? tempObj.city
      : tempObj.city.split(",").map((c) => c.trim());

    const matchedCities = props.cities.filter((city) =>
      cityNames.includes(city.value?.toString()) ||
      cityNames.includes(city.label?.toString())
    );

    setCityValue(matchedCities);
    } else {
      setCityValue([]);
    }


    setDistributorUserList(values);
    setDistributorUserListFull(values);

    setCurrentUser(tempObj);
    setModalShow(true);
    setIsView(true);
  };

  const toggleActive = (userName) => {
    props.toggleUserStatus(userName);
  };

  const Edit = (id) => {
    setIsView(false);
    storage.set("_saveUserData", JSON.stringify(props.Users));
    let users = JSON.parse(storage.get("_saveUserData"));
    let tempObj = users.find((detail) => detail.id === id);
    tempObj.userRole = tempObj.userRoleId;
    // currentUser.userRole
    setUserType({ label: tempObj.userType, value: tempObj.userTypeId });
    setUserRole({ label: tempObj.userRoleName, value: tempObj.userRoleId });
    if (tempObj == null) {
      return;
    }

    handleDistributorSelection(tempObj);

    setUserRolesListForModal(
      props.UserRolesList.filter(
        (x) => x.moduleTypeId == tempObj.userTypeId
      ).map(function (item) {
        return {
          value: item.id,
          label: item.name,
        };
      })
    );

    let values = [...distributorUserList];
    values.forEach((x) => {
      x.isChecked =
        x.value == tempObj.distCenterId?.toUpperCase() ? true : false;
    });

    setDistributorUserList(values);
    setDistributorUserListFull(values);

  if (tempObj.city) {
    const cityNames = Array.isArray(tempObj.city)
      ? tempObj.city
      : tempObj.city.split(",").map((c) => c.trim());

    const matchedCities = props.cities.filter((city) =>
      cityNames.includes(city.value?.toString()) ||
      cityNames.includes(city.label?.toString())
    );

    setCityValue(matchedCities);
    } else {
      setCityValue([]);
    }


    setCurrentUser(tempObj);
    setModalShow(true);
    setIsEdit(true);
  };

  const handleCheckboxSelectAll = (selectedEvent) => {
    setSelectAll(selectedEvent.target.checked);
    let values = [...distributorUserList];
    values.forEach((x) => {
      x.isChecked = selectedEvent.target.checked;
    });

    setDistributorUserList(values);
    setDistributorUserListFull(values);
  };

  const handleCheckboxSelectDistCenter = (selectedEvent, index) => {
    let values = [...distributorUserList];
    values.forEach((x, i) => {
      if (i == index) {
        x.isChecked = selectedEvent.target.checked;
      }
    });
    setDistributorUserList(values);

    values = [...distributorUserListFull];
    values.forEach((x, i) => {
      if (i == index) {
        x.isChecked = selectedEvent.target.checked;
      }
    });

    setDistributorUserListFull(values);

    if (values.filter((x) => x.isChecked == false).length > 0) {
      setSelectAll(false);
    } else {
      setSelectAll(true);
    }
  };

  const OpenModelForAddUsers = () => {
    setCurrentUser({ ...initialValues, tempPassword: "" });
    setUserType(null);
    setModalShow(true);
    setIsView(false);
    setIsEdit(false);
    setDistributor(null);
    setUserRole(null);
    setDistributorUserList([]);
    setDistributorUserListFull([]);

    var filterRoleList = [...rolesList];

    filterRoleList = filterRoleList.filter((x) => x.label != "DeliveryUser");

    setRolesList(filterRoleList);
  };

  const handleSubmit = async (data) => {
    let tempObj = props.Users.find(
      (detail) => detail.userName === data.userName
    );
    if (tempObj != null && !isEdit) {
      toast.error("Selected User details already exist");
      return;
    }
    
    let cities = "";
    if (userType.label === "CoreAppUser") {
      if (city && Array.isArray(city) && city.length > 0) {
        cities = city.map(c => c.value).join(","); // comma-separated
      } else if (currentUser.city && currentUser.city.length > 0) {
        cities = Array.isArray(currentUser.city)
          ? currentUser.city.map(c => c.value || c).join(",")
          : currentUser.city;
      }
    } else {
      cities = city ? city.value : currentUser.city || "";
    }

    let newUserData = {
      id: currentUser.id,
      fullName: data.fullName,
      email: data.email,
      userType: userType?.label,
      cNIC: removeFormatFromNumber(data.cnic),
      userRoleId: userRole?.value,
      contactNumber: removeFormatFromNumber(data.contactNumber),
      newUserRole: data.newUserRole,
      userName: data.userName,
      city: cities,
      password: data.password
    };

    if (newUserData.cNIC.length != 13) {
      toast.error("CNIC must contain 13 digits");

    }

    if (!newUserData.userType) {
      toast.error("Module Type is Required");
    }

    if (
      (userType.label == "DistributorUser" ||
        userType.label == "DeliveryUser") &&
      distributorUserList.filter((x) => x.isChecked == true).length < 1
    ) {
      toast.error("Select Distribution Center(s) for the distributor");
      return;
    } else if (
      (userType.label == "DistributorUser" ||
        userType.label == "DeliveryUser") &&
      distributorUserList.filter((x) => x.isChecked == true).length > 0
    ) {

     let distributorId;

        if (userType.label === "CoreAppUser") {
          if (Array.isArray(distributor) && distributor.length > 0) {
            distributorId = distributor.map(v => v.value).join(",");
          } else {
            distributorId = distributor ? distributor.value : "";
          }
        } else {
          distributorId = distributor ? distributor.value : "";
        }

      newUserData = { ...newUserData, distributorId };
      let IsAllDistCenters = false;
      if (selectAll == true) {
        IsAllDistCenters = true;
      }

      let centers = distributorUserListFull.filter((x) => x.isChecked == true);
      let DistCenterIds = "";

      centers.forEach((x, index) => {
        if (index == 0) {
          DistCenterIds = DistCenterIds.concat(x.value);
        } else {
          DistCenterIds = DistCenterIds.concat(",", x.value);
        }
      });
      newUserData = { ...newUserData, DistCenterIds, IsAllDistCenters };
    }

    if ((userType.label == "Distributor"  || userType.label === "CoreAppUser") && distributor == null) {
      toast.error("Select Distributior");
      return;
    } else if (
      (userType.label == "Distributor" || userType.label === "CoreAppUser") &&
      distributor != null &&
      distributor != ""
    ) {
      let distributorId;

        if (userType.label === "CoreAppUser") {
          if (Array.isArray(distributor) && distributor.length > 0) {
            distributorId = distributor.map(v => v.value).join(","); 
          } else {
            distributorId = distributor ? distributor.value : "";
          }
        } else {
          distributorId = distributor ? distributor.value : "";
        }
      let IsAllDistCenters = true;
        newUserData = { ...newUserData, distributorId, IsAllDistCenters };
    }

    if (!isEdit) {
      var result = await props.addUsers(newUserData);
      if (!result) return;
    } else {
      var result = await props.updateUsers(newUserData);
      if (!result) return;
    }
    await props.getUserRolesList();
    let requestData = {
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText: searchText,
      role: filterRole == "" || filterRole == null ? null : filterRole.value,
      userRole:
        filterUserRole == "" || filterUserRole == null
          ? null
          : filterUserRole.value,
    };
    if (clickedButton.current == "sendEmail") {
      if (!isEdit) {
        props.updateUserPasswordThroughEmail(result.id);
      } else {
        props.updateUserPasswordThroughEmail(currentUser.id);
      }
      toast.success("Email sent to user.");
    }
    setRolesList(rolesListOrignal);
    props.getUsers(requestData);
    selectDistributors();
  };

   useEffect(() => {
    if (filterRole && filterRole.value) {
      const filtered = props.UserRolesList.filter(
        (role) => Number(role.moduleTypeId) === Number(filterRole.value)
      );
      setFilteredUserRoles(filtered);
    } else {
      setFilteredUserRoles([]);
    }
    setFilterUserRole(null);
  }, [filterRole, userRolesList]);

  const userRoleOptions = (Array.isArray(filteredUserRoles) ? filteredUserRoles : [])
    .map((item) => ({
      value: item.id,
      label: item.name,
    }));


  return (
    <div>
      <VzPageContainer title="Manage Users">
        <Row>
          <Col xs={12} md={12}>
            <Button
              className="form-btn pull-right"
              variant="primary"
              style={{ float: "right" }}
              onClick={OpenModelForAddUsers}
            >
              <i className="fa fa-plus" /> Add New User
            </Button>
          </Col>
        </Row>
        <div className="row">
          <Col md={3} style={{ float: "left" }}>
            <div className="form-group">
              <div className="font-weight-bold ml-2 mb-1">Module Type</div>
              <ReactSelect
                id="role"
                name="role"
                className="basic-single"
                classNamePrefix="select"
                placeholder="Select Type"
                isMulti={false}
                value={filterRole}
                isClearable={true}
                onChange={(val) => setFilterRole(val)}
                options={rolesList}
              ></ReactSelect>
            </div>
          </Col>
         <Col md={3} style={{ float: "left" }}>
            <div className="form-group">
              <div className="font-weight-bold ml-2 mb-1">Select Role</div>
              <ReactSelect
                id="userRole"
                name="userRole"
                className="basic-single"
                classNamePrefix="select"
                placeholder="Select Role"
                isMulti={false}
                value={filterUserRole}
                isClearable={true}
                onChange={(val) => setFilterUserRole(val)}
                options={userRoleOptions}
              />
            </div>
          </Col>
        </div>
        <Row>
          <Col xs={12} md={12}>
            <ServerSideDataTable
              data={props.Users ?? []}
              columns={columns}
              getTrProps={(event, data) => null}
              goToPreviousPage={(val) => getData(val)}
              goToNextPage={(val) => getData(val)}
              totalRecords={totalRecords}
              pageSizeChange={(size) => pageSizeChanged(size)}
              myPageSize={currentPageSize}
              myIndex={currentIndex}
              pageNo={currentPageNo}
              searchChanged={searchChanged}
            />
          </Col>
        </Row>

        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          backdrop="static"
          keyboard={false}
          size="lg"
        >
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            {(formik) => (
              <Form autoComplete="off">
                <Modal.Header closeButton>
                  <Modal.Title id="contained-modal-title-vcenter">
                    User Record
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Container>
                    <Row>
                      <Col xs={12} md={3}>
                        <div className="form-group">
                          <FormikControl
                            formik={formik}
                            readOnly={isView}
                            control="input"
                            type="fullName"
                            label="Full Name"
                            name="fullName"
                            maxLength={70}
                            handleOnChange={(e) => (currentUser.fullName = AllowOnlyAlpha(e))}
                            value={currentUser.fullName}
                          />
                        </div>
                      </Col>

                      <Col xs={12} md={3}>
                        <div className="form-group">
                          <FormikControl
                            formik={formik}
                            readOnly={isEdit && currentUser.source == 2}
                            control="cnicNumber"
                            type="cnic"
                            label="CNIC"
                            name="cnic"
                            value={currentUser.cnic}
                            handleOnChange={(e) => (currentUser.cnic = e)}
                          />
                        </div>
                      </Col>

                      <Col xs={12} md={3}>
                        <div className="form-group">
                          <FormikControl
                            formik={formik}
                            readOnly={isView}
                            control="contactNumber"
                            type="contactNumber"
                            label="Contact Number"
                            name="contactNumber"
                            value={currentUser.contactNumber}
                            handleOnChange={(e) =>
                              (currentUser.contactNumber = e)
                            }
                          />
                        </div>
                      </Col>

                      <Col xs={12} md={3}>
                        <div className="form-group">
                          <FormikControl
                            formik={formik}
                            readOnly={isView}
                            control="input"
                            type="email"
                            label="Email"
                            name="email"
                            maxLength={254}
                            autoComplete="new-email"
                            value={currentUser.email}
                            handleOnChange={(e) => (currentUser.email = e)}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={4}>
                        <div className="form-group">
                          <FormikControl
                            formik={formik}
                            control="react-select"
                            readOnly={
                              isView ||
                              isEdit ||
                              userType?.label == "DeliveryUser"
                            }
                            type="userType"
                            label="Module Type"
                            name="userType"
                            value={userType}
                            options={rolesList}
                            handleOnChange={(value) => {
                              currentUser.userType = value.label;
                              setUserType(value);
                              clearDistributorSection();
                              setCityValue([]);
                              setDistributor(null);
                              setSearchCenter("");
                              setUserRolesListForModal(
                                props.UserRolesList.filter(
                                  (x) => x.moduleTypeId == value.value
                                ).map(function (item) {
                                  return {
                                    value: item.id,
                                    label: item.name,
                                  };
                                })
                              );
                            }}
                          />
                        </div>
                      </Col>
                      {userType &&
                        (userType.label == "Distributor" ||
                          userType.label == "CoreAppUser" ||
                          userType.label == "DistributorUser" ||
                          userType.label == "DeliveryUser") ? (
                        <>
                          <Col xs={12} md={4}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                type="userRole"
                                label="User Role"
                                name="userRole"
                                value={userRole}
                                isDisabled={currentUser.newUserRole || isView}
                                options={userRolesListForModal}
                                isClearable={true}
                                handleOnChange={(value) => {
                                  if (value == null) {
                                    currentUser.userRole = null;
                                    setUserRole(null);
                                  } else {
                                    currentUser.userRole = value.label;
                                    setUserRole(value);
                                  }
                                 
                                }}
                              />
                            </div>
                          </Col>
                          <Col xs={12} md={4}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                readOnly={isView || isEdit}
                                control="input"
                                type="newUserRole"
                                label="Custom Role"
                                autoComplete="new-newUserRole"
                                maxLength={50}
                                name="newUserRole"
                                disabled={currentUser.userRole || isView}
                                value={currentUser.newUserRole}
                                handleOnChange={(e) =>
                                  (currentUser.newUserRole = e)
                                }
                              />
                            </div>
                          </Col>
                        </>
                      ) : (
                        userType && (
                          <>
                            <Col xs={12} md={4}>
                              <div className="form-group">
                                <FormikControl
                                  formik={formik}
                                  control="input"
                                  type="userName"
                                  label="User Name"
                                  name="userName"
                                  disabled={isView}
                                  value={currentUser.userName}
                                  handleOnChange={(e) =>
                                    (currentUser.userName = e)
                                  }
                                />
                              </div>
                            </Col>
                            <Col xs={12} md={4}>
                              <div className="form-group">
                                <FormikControl
                                  formik={formik}
                                  control="input"
                                  type="password"
                                  label="Password"
                                  name="password"
                                  autoComplete="new-password"
                                  disabled={isView}
                                  value={currentUser.password}
                                  handleOnChange={(e) =>
                                    (currentUser.password = e)
                                  }
                                />
                              </div>
                            </Col>
                          </>
                        )
                      )}
                    </Row>
                {userType &&
                  (userType.label == "Distributor" ||
                    userType.label == "CoreAppUser" ||
                    userType.label == "DistributorUser" ||
                    userType.label == "DeliveryUser") ? (
                  <Row>
                    { (userType.label == "CoreAppUser")? (
                   <Col xs={12} md={4}>
                    <div className="form-group">
                      <FormikControl
                          formik={formik}
                          readOnly={isView || userType.label === "DeliveryUser"}
                          control="react-select"
                          type="city"
                          label="City"
                          name="city"
                          isMulti={userType.label === "CoreAppUser"}
                          options={props.cities}
                          isSearchable={false}
                          isClearable={true} 
                          handleOnChange={(selectedOptions) => {
                            if (!selectedOptions || (Array.isArray(selectedOptions) && selectedOptions.length === 0)) {
                              setCityValue([]);
                              setDistributor(null);
                              setSearchCenter("");
                              return;
                            }
                            setCityValue(selectedOptions);
                            setDistributor(null);
                            setSearchCenter("");
                            selectDistributors(selectedOptions);
                          }}
                          value={city}
                        />
                        </div>
                       </Col>
                      ) : (
                          <></>
                        )}
                  
                    <Col xs={12} md={6}>
                      <div className="form-group">
                  <FormikControl
                    formik={formik}
                    control="react-select"
                    readOnly={isView || userType.label == "DeliveryUser"}
                    type="distributor"
                    label="Distributor"
                    name="distributor"
                    value={distributor}
                    options={distributorOptions}
                    isMulti={userType.label === "CoreAppUser"}
                    handleOnChange={(selectedOptions) => {
                      let finalSelection = selectedOptions;

                      if (userType.label === "CoreAppUser") {
                        const isSelectAllChosen = selectedOptions?.some(opt => opt.value === "ALL");

                        if (isSelectAllChosen) {
                          finalSelection = props.allDistributorList;
                        }
                      }
                      currentUser.distributor = finalSelection;
                      setDistributor(finalSelection);
                      userType.label === "CoreAppUser"
                        ? setSearchCenter("")
                        : setDistributor(finalSelection);
                     }}
                    />
                    </div>
                    </Col>
                     {userType &&
                    (userType.label !== "CoreAppUser") ? (
                    <Col xs={12} md={6}>
                      <div className="form-group ">
                        <label className="mb-0">Dist Centers</label>
                        <input
                          value={searchCenter}
                          type="text"
                          className="form-control mb-3"
                          onChange={(e) => filterCenters(e)}
                          readOnly={
                            userType.label == "Distributor" ||
                            isView ||
                            userType.label == "DeliveryUser"
                          }
                        />
                        {distributorUserList?.length > 0 ? (
                          <div className="ms-2 border-bottom mb-2 ">
                            <input
                              disabled={
                                userType.label == "Distributor" ||
                                isView ||
                                userType.label == "DeliveryUser"
                              }
                              value={selectAll}
                              checked={selectAll}
                              onChange={(event) => handleCheckboxSelectAll(event)}
                              type="checkbox"
                              style={{ transform: "scale(1.3)" }}
                            />
                            <span className="ms-2">Select All</span>
                          </div>
                        ) : (
                          <></>
                        )}

                        <div className="overflow-auto " style={{ maxHeight: "100px" }}>
                          {distributorUserList.map((item, index) => {
                            return (
                              <div className="ms-2 my-2" key={index}>
                                <input
                                  disabled={
                                    (userType.label == "Distributor" ||
                                      userType.label == "DeliveryUser" ||
                                      isView) &&
                                    userType.label !== "CoreAppUser"
                                  }
                                  checked={item.isChecked}
                                  value={item.value}
                                  type="checkbox"
                                  onChange={(event) =>
                                    handleCheckboxSelectDistCenter(event, index)
                                  }
                                  style={{ transform: "scale(1.3)" }}
                                />
                                <span className="ms-2">{item.label}</span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </Col>
                    ): (
                  <></>
                )}
                  </Row>
                ) : (
                  <></>
                )}
                  </Container>
                </Modal.Body>
                <Modal.Footer>
                  {isView ? null : (
                    <>
                      <div className="d-flex justify-content-between w-100">
                        <div>
                          <input
                            type="submit"
                            className="btn btn-primary"
                            disabled={
                              !(
                                userType?.label == "Distributor" ||
                                userType?.label == "DistributorUser" ||
                                userType?.label == "DeliveryUser" ||
                                userType?.label == "CoreAppUser"
                              )
                            }
                            value="Send Email"
                            onClick={() =>
                              (clickedButton.current = "sendEmail")
                            }
                          />
                        </div>
                        <div>
                          <Button
                            className="btn btn-default mr-1"
                            onClick={() => {
                              setRolesList(rolesListOrignal);
                              setModalShow(false);
                            }}
                          >
                            Close
                          </Button>
                          <input
                            type="submit"
                            className="btn btn-primary"
                            value="Save"
                            onClick={() => (clickedButton.current = "save")}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
      </VzPageContainer>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    AddUser: state.Users?.addUser ? state.Users.getUserList : {},
    Users: state.Users?.getUserList ? state.Users.getUserList : [],
    Roles: state.ddlList?.userRoles ? state.ddlList?.userRoles : [],
    UserRolesList: state.ddlList?.UserRolesList
      ? state.ddlList?.UserRolesList
      : [],
    allDistributorList: state.ddlList.allDistributorList
      ? state.ddlList.allDistributorList
      : [],
    distCentersddlList: state.ddlList.selectedDistCentersList
      ? state.ddlList.selectedDistCentersList
      : [],
      cities: state.ddlList.cities ? state.ddlList.cities : [],
    PermissionRoles: state.UserRoles,
  };
};
export default connect(mapStateToProps, {
  addUsers,
  getUsers,
  updateUsers,
  deleteUsers,
  getUserRoles,
  getUserRolesList,
  getDropdownList,
  getDropdownListByPost,
  getRolesList,
  toggleUserStatus,
  updateUserPasswordThroughEmail,
})(ManageUsers);
